import React from "react";
import { useTranslation } from "react-i18next";
import * as authSelector from "../../../store/selectors/authSelectors";
import * as hostsSelector from "../../../store/selectors/hostsSelectors";
import { useSelector } from "react-redux";
// components
import useLanguage from "../../common/useLanguage";
import useLogout from "../../common/useLogout";
// assets / style
import {
  ActionItem,
  Actions,
  BaseItem,
  AppContainer,
  LogoContainer,
  NavBarOptions,
  TextItem,
  ZikaronLogo,
  ActionItemLogout
} from "./style";

import zikaronLogo from "../../../assets/icons/zikaronLogo.svg";
import zikaronLogoEng from "../../../assets/icons/zikaronLogoEng.svg";
import NavBarActionsHost from "./NavBarActionHost";

import { Link, withRouter } from "react-router-dom";
import ButtonSmall from "../../common/ButtonSmall";
import * as guestsSelector from "../../../store/selectors/guestsSelectors";
import LanguageToggle from "../../common/LanguageToggle/LanguageToggle";
import { buildPath } from "../../../utils/constants/routes";

const DesktopHost = ({ history }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();
  const logout = useLogout();
  const firstName = useSelector(authSelector.firstNameSelector);
  const lastName = useSelector(authSelector.lastNameSelector);
  const role = useSelector(authSelector.roleSelector);
  const token = useSelector(authSelector.tokenSelector);
  const hostId = useSelector(hostsSelector.hostIdSelector);
  const hostProfile = useSelector(hostsSelector.hostProfileSelector);
  const guestId = useSelector(guestsSelector.guestIdSelector);

  const fullName = (hostProfile?.first_name && hostProfile?.last_name)
    ? `${hostProfile.first_name} ${hostProfile.last_name}`
    : (firstName && lastName) ? `${firstName} ${lastName}` :
      t(`admin.header.userItems.${role}`);

  const [selectedLanguage, onLangugageChange] = useLanguage();
  const locationForHeader = window.location.href.split("site")?.[1];
  const salonUrl = role==="host" ? '/host/' + hostId : '/guest/' + guestId;
  const navigateToSalonSearch = () => history.push(buildPath(`/site${salonUrl}/salon`));

  return (
    <>
      {locationForHeader !== `/host/${hostId}/salon` &&
        locationForHeader !== `/host/${hostId}/profile` &&
        locationForHeader !== `/host/${hostId}/profile/profile` &&
        locationForHeader !== `/host/${hostId}/profile/salon`
        ? (
          <AppContainer dir={language === "he" ? "rtl" : "ltr"}>
            <Actions>
              <LogoContainer
                  href={
                    role === "guest" || role === "host" || role === "witness"
                      ? language === "he" ? "https://www.zikaronbasalon.com/" : "http://www.zikaronbasalon.com/en/"
                      : "https://app.zikaronbasalon.com/admin"
                  }
              >
               <ZikaronLogo src={language === "he" ? zikaronLogo : zikaronLogoEng} alt="logo"></ZikaronLogo>
              </LogoContainer>
            </Actions>
            {token ? 
            <Actions>
              <ButtonSmall
                width={130}
                height={"54px"}
                colorType={"white"}
                colorProps={"black"}
                borderProps={"1px solid black"}
                position={"relative"}
                fontSize={"16px"}
               onClick={navigateToSalonSearch}
              >
                <Link
                  to={`/site${salonUrl}/salon`}
                  style={{ color: "black", textDecoration: "none" }}
                >
                  {t("host.exit")}
                </Link>
              </ButtonSmall>
            </Actions>
            : <LanguageToggle/>}
          </AppContainer>
        ) : (
          <AppContainer dir={language === "he" ? "rtl" : "ltr"}>
            <Actions>
              <LogoContainer
                  href={
                    role === "guest" || role === "host" || role === "witness"
                      ? language === "he" ? "https://www.zikaronbasalon.com/" : "http://www.zikaronbasalon.com/en/"
                      : "https://app.zikaronbasalon.com/admin"
                  }
              >
                <ZikaronLogo src={language === "he" ? zikaronLogo : zikaronLogoEng} alt="logo"></ZikaronLogo>
              </LogoContainer>
              <BaseItem>
                {`${t("admin.header.userItems.greetings")} ${token && fullName
                  }`}
              </BaseItem>
              <NavBarOptions>
                <NavBarActionsHost history={history} />
              </NavBarOptions>
            </Actions>
            <Actions>
              <ActionItemLogout clickable onClick={logout}>
                {token
                  ? t("admin.header.userItems.logout")
                  : t("admin.header.userItems.login")}
              </ActionItemLogout>
              <LanguageToggle/>
            </Actions>
          </AppContainer>
        )}
    </>
  );
};

export default withRouter(DesktopHost);